<mat-toolbar class="flex items-center gap-3 px-4 py-3 shadow-pmdf-overlay bg-pmdf-primary">
    <!-- Menu toggle (mobile = open/close, desktop = expand/rail) -->
    <button
      mat-icon-button
      (click)="toggleSidenav()"
      class="text-pmdf-base-secondary font-light"
      [attr.aria-label]="isMobile() ? 'Abrir menu' : 'Alternar menu'" 
    >
      <mat-icon class="icon-lg" >{{ isMobile() ? 'menu' : (sidenavExpanded() ? 'menu_open' : 'menu') }}</mat-icon>
    </button>
  
    <div class="flex-1"></div>
  
    <!-- Toolbar actions -->
    <div class="flex items-center gap-2">
      @if (flagService.isEnabled('buscaGlobal')) {
        <app-toolbar-search />
      }
      @if (pwaInstallService.canInstall() && !pwaInstallService.isInstalled()) {
        <button mat-icon-button
                matTooltip="Instalar aplicativo"
                (click)="instalarApp()"
                class="text-pmdf-base-secondary">
          <mat-icon class="icon-lg">install_mobile</mat-icon>
        </button>
      }
      <app-toolbar-notifications />
      
      <!-- COPILOTO IA PROVID -->
      <button
        mat-icon-button
        (click)="copilot.toggleDrawer()"
        class="text-pmdf-base-secondary font-light"
        aria-label="Copiloto PROVID IA"
        matTooltip="Copiloto de IA PROVID"
      >
        <mat-icon class="icon-lg text-pmdf-accent animate-pulse">psychology</mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="toggleQuickpanel()"
        class="text-pmdf-base-secondary font-light"
        aria-label="Painel de atividades"
        matTooltip="Resumo de atividades"
      >
        <mat-icon class="icon-lg">format_list_bulleted</mat-icon>
      </button>
  
      <app-toolbar-user />
    </div>
  </mat-toolbar>
  